import styled from 'styled-components'
import { devices } from '../../../../globalStyle'

export const MenuContainer = styled.div`
  position: fixed;
  background-color: #fff;
  width: 13vw;
  padding-top: 0.3vh;
  flex-direction: column;
  z-index: 2147483647;
  border: 1px solid #ebebeb;
  border-top-left-radius: 1vw;
  border-bottom-left-radius: 1vw;
  border-bottom-right-radius: 1vw;
  box-shadow: 0px 8px 16px 0px #0000001a;

  @media ${devices.largeDesktop} {
    width: 11vw;
  }
`

export const MenuTitle = styled.h2`
  font-size: 1.1vw;
  margin-left: 0.9vw;
  margin-bottom: 0;
  margin-top: 0.8vh;

  @media ${devices.largeDesktop} {
    font-size: 1vw;
  }
`

export const FieldLabel = styled.label`
  display: block;
  margin-left: 1vw;
  margin-top: 1.2vh;
  font-size: 0.75vw;
  color: #696969;
  font-weight: 600;

  @media ${devices.largeDesktop} {
    font-size: 0.65vw;
  }
`

export const FilterTextInput = styled.input`
  width: 11vw;
  height: 5.2vh;
  background-color: #ebebeb;
  border: 0;
  padding: 0 1.2vw;
  margin-top: 0.6vh;
  margin-left: 1vw;
  border-radius: 2vw;
  font-size: 0.9vw;

  @media ${devices.largeDesktop} {
    font-size: 0.7vw;
    width: 9vw;
  }

  :focus {
    outline: 0;
  }
`

export const ActionsRow = styled.div`
  display: flex;
  gap: 0.5vw;
  margin-top: 1.5vh;
  margin-left: 1vw;
  margin-bottom: 1.5vh;
`

export const ApplyButton = styled.button`
  width: 5.2vw;
  height: 5.2vh;
  background-color: #0090d3;
  border: 0;
  border-radius: 2vw;
  font-size: 0.85vw;
  color: #fff;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    font-size: 0.75vw;
    width: 4.2vw;
  }
`

export const ClearButton = styled.button`
  width: 5.2vw;
  height: 5.2vh;
  background-color: #ebebeb;
  border: 0;
  border-radius: 2vw;
  font-size: 0.85vw;
  color: #333;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    font-size: 0.75vw;
    width: 4.2vw;
  }
`
